// Sales effectiveness table (approved HTML component: sales-effectiveness).
import type { ReactNode } from 'react';
import { useState } from 'react';

export type SalesView = 'teams' | 'reps';

export interface SalesEffectivenessProps {
  rows: Array<{
    team: string;
    contact: string;
    close: string;
    rpc: string;
    sales: string;
  }>;
}

export function SalesEffectiveness({ rows }: SalesEffectivenessProps): ReactNode {
  const [view, setView] = useState<SalesView>('teams');
  return (
    <section className="exec-card" data-component="sales-effectiveness">
      <div className="exec-head">
        <h2>Sales effectiveness</h2>
        <div className="sales-view-toggle" role="group" aria-label="Sales results view">
          <button
            type="button"
            data-sales-view="teams"
            aria-pressed={view === 'teams'}
            onClick={() => setView('teams')}
          >
            Teams
          </button>
          <button
            type="button"
            data-sales-view="reps"
            aria-pressed={view === 'reps'}
            onClick={() => setView('reps')}
          >
            Reps
          </button>
        </div>
      </div>
      <table className="effectiveness-table">
        <thead>
          <tr>
            <th>Team / rep</th>
            <th>Contact rate</th>
            <th>Close rate</th>
            <th>Revenue / reached customer</th>
            <th>CRM-attributed sales</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(row => (
            <tr key={row.team}>
              <td>
                <strong>{row.team}</strong>
              </td>
              <td>{row.contact}</td>
              <td>{row.close}</td>
              <td>{row.rpc}</td>
              <td>{row.sales}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="exec-body">
        <p className="exec-note">
          CRM-attributed sales track rep and team performance. The company total is shown separately
          above.
        </p>
      </div>
    </section>
  );
}
